import { render, staticRenderFns } from "./ForgotPasswordCode.vue?vue&type=template&id=5a656656&scoped=true"
import script from "./ForgotPasswordCode.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCode.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCode.vue?vue&type=style&index=0&id=5a656656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a656656",
  null
  
)

export default component.exports